import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import { routes } from "../../../routes";
import { translate } from "../../translate";

import "./style.css";

class Header extends Component {


    render() {
        const path_excepts = ["/", "/lead/:id"];
        const routes_header = routes.filter(r => !!!path_excepts.includes(r.path)).map(r => {
            r["isActive"] = false;
            if(window.location.pathname === r.path) r["isActive"] = true;
            return r;
        });

        return (
            <div>
                <nav className="navbar navbar-default">
                    <div className="container-fluid">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            {/* <a className="navbar-brand" >WebSiteName</a> */}
                        </div>
                        <div className="collapse navbar-collapse" id="myNavbar">
                            <ul className="nav navbar-nav">
                                {routes_header.map((r, i) => (
                                    <li key={i} className={ r.isActive ? "active" : "" }>
                                        <Link to={r.path}>
                                            {translate(r.name || r.path)}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                            <ul className="nav navbar-nav navbar-right">
                                <li>
                                    <Link to="/">
                                        <span className="glyphicon glyphicon-log-out"></span> {translate("header.sair","Sair")}
                                </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        )
    }
}

// "state" is set in reducers/index.js
function mapStateToProps(state) {
    return {
        //user: state.user
    };
}

export default connect(mapStateToProps)(Header);